export function removeWhitespaces(input: string): string {
  // This matches any whitespace before and after "=" and one or more whitespace characters at the end of the string
  return input.replace(/\s*=\s*/g, "=").trim();
}
